import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import { bytesToString } from "@/utils/utils";
import localize from "@/utils/localization";
import { computed } from "vue";
import { faChartBar, faUndo, faTrash, faInfoCircle, faArchive } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectedItemActions',
    props: {
        data: null,
        isRecoverable: { type: Boolean },
        itemType: null,
        isArchived: { type: Boolean, default: false }
    },
    emits: ["view-item", "undelete-item", "permanently-delete-item"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faChartBar, faUndo, faTrash, faInfoCircle, faArchive);
        const label = computed(() => { var _a, _b; return (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "No data"; });
        const prettySize = computed(() => { var _a, _b; return bytesToString((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0); });
        const viewDetailsIcon = computed(() => (props.itemType === "history" ? "chart-bar" : "info-circle"));
        function onUndeleteItem() {
            emit("undelete-item", props.data.id);
        }
        function onViewItem() {
            emit("view-item", props.data.id);
        }
        function onPermanentlyDeleteItem() {
            emit("permanently-delete-item", props.data.id);
        }
        return { __sfc: true, props, label, prettySize, viewDetailsIcon, emit, onUndeleteItem, onViewItem, onPermanentlyDeleteItem, BButton, localize, FontAwesomeIcon };
    }
});
